export default __webpack_public_path__ + "static/media/BookReader.61c9c27c.png";